<template>
  <BaseWarning>
    <i18n path="warnings.transitions.unsuitablePartnerships" tag="span">
      <template #instructions>{{ instructionList }}</template>
      <template #mainPartnershipType>
        {{ $t(`warnings.transitions.${data.mainPartnershipType}Partnerships`) }}
      </template>
      <template #consequence>
        <a href="https://www.guidetofm.com/tactics/transition-play/" target="_blank">
          {{ consequence }}
        </a>
      </template>
    </i18n>
  </BaseWarning>
</template>

<script>
import BaseWarning from "./BaseWarning.vue";
import PartnershipTypes from "@/assets/js/partnership-types";

export default {
  name: "WarningTransitionPartnerships",
  
  props: {
    data: Object
  },

  components: { BaseWarning },

  computed: {
    consequence: function () {
      const consequence = (
        this.data.mainPartnershipType === PartnershipTypes.direct ?
        "hinderQuickTransitions" :
        "slowTransitions"
      );
      return this.$t(`warnings.transitions.${consequence}`);
    },

    instructionList: function() {
      const instructionNames = [];
      for (const instruction of this.data.instructions) {
        instructionNames.push(this.$t(`tactics.instructions.transitions.${instruction.transitionType}.${instruction.instruction}`));
      }
      if (instructionNames.length === 1) return instructionNames[0];
      return this.$t('warnings.transitions.join2instructions', instructionNames);
    }
  },
};
</script>
